<template>
  <Modal v-model="priceAdjustmentModal" :title="$t('key1000162')" width="1100" :transfer="false" class-name="priceAdjustmentStyle"
    :mask-closable="false" @on-visible-change="priceAdjustmentChange">
    <div v-for="(item,index) in priceAdjustmentList" :key="index" class="mb30">
      <div class="flex align-items-center justify-content-between mb5">
        <div class="flex flex-direction">
          <p>{{ item.subPackageCode }}</p>
          <p class="mt2 mb2">{{ $t('key1003343') + item.supplierMerchantId }}</p>
        </div>
        <Row style="width: 60%;" justify="end">
          <Col :xxl="twoItemCol" :xl="twoItemCol" :lg="twoItemCol" :md="twoItemCol">
            <div class="flex align-items-center justify-content-end">
              <span>{{ $t('key1004313') }}</span>
              <InputNumber
                style="width: 120px"
                :min="0"
                :max="9999999"
                :formatter="(value) => formatterNumber(value, 2)"
                v-model.trim="item.distributorPayAmount">
              </InputNumber>
              <span class="ml5">{{ item.distributorTotalPriceCurrency }}</span>
            </div>
          </Col>
          <Col :xxl="twoItemCol" :xl="twoItemCol" :lg="twoItemCol" :md="twoItemCol">
            <div class="flex align-items-center justify-content-end">
              <span>{{ $t('key1004314') }}</span>
              <InputNumber
                style="width: 120px"
                :min="0"
                :max="9999999"
                :formatter="(value) => formatterNumber(value, 2)"
                v-model.trim="item.supplierPayAmount">
              </InputNumber>
              <span class="ml5">{{ item.totalPriceCurrency }}</span>
            </div>
          </Col>
        </Row>
      </div>
      <Table
        row-key="id"
        highlight-row
        border
        max-height="400"
        :loading="tableLoading"
        :columns="tableColumns"
        :data="item.tableData">
      </Table>
    </div>
    <template #footer>
      <div class="flex align-items-center justify-content-between">
        <div class="flex flex-direction">
          <p class="mt2 mb2">
            {{ $t('key1004311') + distributorTotalPriceCurrency + ' ' + totalAmountOfSupplierOrders }}
          </p>
          <p class="mt2 mb2">
            {{ $t('key1004312') + totalPriceCurrency + ' ' + totalAmountOfDistributorOrders }}
          </p>
        </div>
        <div class="flex align-items-center">
          <Button class="mr15" @click="priceAdjustmentModal = false">{{ $t('key1000112') }}</Button>
          <Button class="mr15" :disabled="priceAdjustmentList.length <=0" type="primary" @click="priceAdjustmentBtn(1)">{{ $t('key1000555') }}</Button>
          <Button class="mr15" :disabled="priceAdjustmentList.length <=0" type="primary" @click="priceAdjustmentBtn(2)">{{ $t('key1004315') }}</Button>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {formatterNumber, isValueEmpty} from "@/utils/common";

export default {
  name: 'priceAdjustmentModal',
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      priceAdjustmentModal: false,
      tableColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000383'),
          minWidth: 300,
          key: 'productInfo',
          align: 'left',
          tree: true,
          className: 'set_productInfo_box',
          render(h, params) {
            let children = params.row.children || [];
            if (children.length > 0) {
              let ymsSpu = params.row.ymsSpu;
              let name = params.row.name;
              let list = [
                v.tableImg(h, params, 'imgPath'),
                h('div', {
                  class: 'text-align-left pl10'
                }, [
                  h('Alink', {
                    props: {
                      AlinkShow: false,
                      linkName: name,
                      textAlign: 'left',
                      className: 'mb5',
                      AlinkClass: 'ellipsis_2'
                    }
                  }),
                  h('p', {class: 'flex align-items-center'}, [
                    h('span', aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000689')),
                    h('Alink', {
                      props: {
                        AlinkShow: false,
                        linkName: ymsSpu,
                        textAlign: 'left',
                        AlinkClass: 'distributorThemeColor'
                      }
                    })
                  ]),
                ])
              ];
              return h('div', {
                class: 'flex ptb10',
              }, list);
            } else {
              let newList = [];
              let ymsSku = params.row.ymsSku;
              let productGoodsSpecificationList = params.row.productGoodsSpecificationList || [];
              if (productGoodsSpecificationList.length > 0) {
                newList = productGoodsSpecificationList.map((item) => {
                  return item.value;
                });
              }
              return h('div', {style: {width: '100%', textAlign: 'right'}}, [
                h('p', {class: 'mt2 mb2'}, ymsSku),
                h('p', {class: 'mt2 mb2 color-green'}, newList.join(' • '))
              ]);
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000523'),
          key: 'quantity',
          minWidth: 110,
          align: 'left',
          render(h, params) {
            let children = params.row.children || [];
            if (children.length > 0) {
              let totalNum = children.reduce((acc, curr) => acc + curr.quantity, 0);
              return h('span', totalNum);
            } else {
              return h('span', params.row.quantity);
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000882'),
          key: 'supplyPrice',
          minWidth: 140,
          align: 'left',
          render(h, params) {
            let productGoodsCurrency = params.row._productInfo.currency;
            let children = params.row.children || [];
            let parentLevelTalg = params.row.parentLevelTalg;
            if (parentLevelTalg) {
              let text = productGoodsCurrency + ' ' + 0;
              let maxNum = Math.max(...children.map(obj => obj._productInfo.supplyPrice));
              let minNum = Math.min(...children.map(obj => obj._productInfo.supplyPrice));
              if (maxNum || minNum) {
                if (maxNum === minNum) {
                  text = productGoodsCurrency + ' ' + maxNum;
                } else {
                  text = productGoodsCurrency + ' ' + (minNum + ' ~ ' + maxNum);
                }
              }
              return h('span', text);
            } else {
              let _productInfo = params.row._productInfo;
              return h('span', productGoodsCurrency + ' ' + _productInfo.supplyPrice);
            }
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003365'),
          key: 'salesPrice',
          align: 'left',
          minWidth: 140,
          render(h, params) {
            let productGoodsCurrency = params.row._productInfo.currency;
            let children = params.row.children || [];
            let parentLevelTalg = params.row.parentLevelTalg;
            if (parentLevelTalg) {
              let text = productGoodsCurrency + ' ' + 0;
              let maxNum = Math.max(...children.map(obj => obj._productInfo.suggestPrice));
              let minNum = Math.min(...children.map(obj => obj._productInfo.suggestPrice));
              if (maxNum || minNum) {
                if (maxNum === minNum) {
                  text = productGoodsCurrency + ' ' + maxNum;
                } else {
                  text = productGoodsCurrency + ' ' + (minNum + ' ~ ' + maxNum);
                }
              }
              return h('span', text);
            } else {
              let _productInfo = params.row._productInfo;
              return h('span', productGoodsCurrency + ' ' + _productInfo.suggestPrice);
            }
          }
        }
      ],
      priceAdjustmentList: [],
      ymsStockUpInfoId: null,
      totalAmountOfSupplierOrders: 0,
      totalAmountOfDistributorOrders: 0
    };
  },
  computed: {
    distributorTotalPriceCurrency() {
      let currency = '';
      if (this.priceAdjustmentList.length > 0) {
        currency = this.priceAdjustmentList[0].distributorTotalPriceCurrency;
      }
      return currency;
    },
    totalPriceCurrency() {
      let currency = '';
      if (this.priceAdjustmentList.length > 0) {
        currency = this.priceAdjustmentList[0].totalPriceCurrency;
      }
      return currency;
    }
  },
  methods: {
    formatterNumber,
    // 初始化数据
    initPriceAdjustmentData(data) {
      this.ymsStockUpInfoId = data.ymsStockUpInfoId;
      this.getDetailsData(data.ymsStockUpInfoId);
    },
    // 获取详情数据
    getDetailsData(ymsStockUpInfoId) {
      let v = this;
      let ymsProductGoodsIdList = [];
      v.tableLoading = true;
      v.axios.get(api.get_ymsSubPackageInfo_queryStockPackageDetail + `${ymsStockUpInfoId}`).then(response => {
        v.tableLoading = false;
        if (response.data.code === 0) {
          let data = response.data.datas || [];
          if (data.length > 0) {
            data.map((item) => {
              let ymsSubPackageGoodsList = item.ymsSubPackageGoodsList || [];
              if (ymsSubPackageGoodsList.length > 0) {
                ymsSubPackageGoodsList.map((ele) => {
                  ele.subPackageCode = item.subPackageCode;
                  ymsProductGoodsIdList.push(Object.assign({}, item, ele));
                });
              } else {
                ymsProductGoodsIdList.push(item);
              }
            });
          }
          if (ymsProductGoodsIdList.length > 0) {
            let ymsProductGoodsIds = ymsProductGoodsIdList.map((item) => {
              return item.ymsProductGoodsId;
            });
            const {ymsWarehouseId,distributorMerchantId} = data[0];
            v.getProductInfoByBo({
              ymsProductGoodsIds,
              ymsWarehouseId,
              distributorMerchantId
            }, ymsProductGoodsIdList).then((newData) => {
              if (newData && newData.length > 0) {
                newData.map((item) => {
                  let name = item._productInfo ? item._productInfo._spuInfo ? item._productInfo._spuInfo.name : null : null;
                  let productGoodsSpecificationList = item._productInfo ? item._productInfo.productGoodsSpecificationList : null;
                  let skuImgPath = item._productInfo.primaryImage || '';
                  let spuImgPath = item._productInfo._spuInfo.primaryImage || '';
                  let imgPath = skuImgPath ? skuImgPath : spuImgPath;
                  let suggestPrice = item._productInfo ? item._productInfo.suggestPrice : null;
                  item.name = name;
                  item.imgPath = imgPath;
                  item.ymsSpu = item._productInfo ? item._productInfo._spuInfo ? item._productInfo._spuInfo.ymsSpu : null : null;
                  item.productGoodsSpecificationList = productGoodsSpecificationList;
                  item.suggestPrice = suggestPrice;
                });

                // 处理分组
                let packageCodeMap = new Map();
                newData.forEach((item, index) => {
                  let {subPackageCode, supplierMerchantId, ymsSpu, ymsSku, imgPath, name, ...obj} = item;
                  let ymsSubPackageGoodsList = item.ymsSubPackageGoodsList || [];
                  // 初始化 subPackageCode 数据
                  if (!packageCodeMap.has(subPackageCode)) {
                    packageCodeMap.set(subPackageCode, {
                      subPackageCode,
                      supplierMerchantId,
                      ...obj,
                      tableData: [],
                      distributorPayAmount: item.distributorTotalPrice,
                      supplierPayAmount: item.totalPrice,
                    }
                    );
                  }
                  let tableData = packageCodeMap.get(subPackageCode).tableData;
                  // 初始化 ymsSpu 数据
                  if (!tableData.some((spuItem) => spuItem.ymsSpu === ymsSpu)) {
                    tableData.push({
                      id: 'parentLevel_' + ymsSpu,
                      ...obj,
                      ymsSpu,
                      name,
                      imgPath,
                      parentLevelTalg: true,
                      children: []
                    });
                  }
                  let children = tableData.find((spuItem) => spuItem.ymsSpu === ymsSpu).children;
                  // 添加 sku 数据
                  let skuObj = {};
                  let arr = ymsSubPackageGoodsList.filter((ele) => {
                    return ele.ymsSku === ymsSku;
                  });
                  if (arr.length > 0) {
                    skuObj = arr[0];
                  }
                  skuObj = Object.assign({}, skuObj, {
                    id: 'childrenLevel_' + index + ymsSku,
                    parentLevelTalg: false,
                    ymsSku,
                    ...obj
                  });
                  children.push(skuObj);
                });
                // 将 Map 转为数组
                let packageCodeList = Array.from(packageCodeMap.values());
                if (packageCodeList.length > 0) {
                  this.totalAmountOfSupplierOrders = packageCodeList.reduce((accumulator, currentValue) => {
                    return accumulator + currentValue.totalPrice;
                  }, 0);
                  this.totalAmountOfDistributorOrders = packageCodeList.reduce((accumulator, currentValue) => {
                    return accumulator + currentValue.distributorTotalPrice;
                  }, 0);
                }
                v.priceAdjustmentList = packageCodeList;
                v.priceAdjustmentModal = true;
              }
            });
          }
        }
      });
    },
    // 保存、保存并下单
    priceAdjustmentBtn(type) {
      let v = this;
      let text = type === 1 ? aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000113') : aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004310');
      let query = {
        operationType: type,
        updateYmsStockUpInfoSubBargainBos: [],
        ymsStockUpInfoId: v.ymsStockUpInfoId
      };
      for (let i = 0; i < v.priceAdjustmentList.length; i++) {
        let distributorPayAmount = v.priceAdjustmentList[i].distributorPayAmount;
        let supplierPayAmount = v.priceAdjustmentList[i].supplierPayAmount;
        let subPackageCode = v.priceAdjustmentList[i].subPackageCode;
        let ymsSubPackageId = v.priceAdjustmentList[i].ymsSubPackageId;
        if (isValueEmpty(distributorPayAmount) || isValueEmpty(supplierPayAmount)) {
          v.$Message.warning(`${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1001887')} ${subPackageCode} ${aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004309')}`);
          return false;
        } else {
          query.updateYmsStockUpInfoSubBargainBos.push({
            distributorPayAmount: distributorPayAmount,
            supplierPayAmount: supplierPayAmount,
            ymsSubPackageId: ymsSubPackageId
          });
        }
      }
      if (query.updateYmsStockUpInfoSubBargainBos.length === v.priceAdjustmentList.length) {
        v.axios.post(api.post_ymsStockUpInfo_saveBargain, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
          if (response.data.code === 0) {
            v.priceAdjustmentModal = false;
            v.$Message.success(text);
            v.$emit('updateData', true);
          }
        });
      }
    },
    // 监听弹窗
    priceAdjustmentChange(val) {
      if (!val) {
        this.priceAdjustmentList = [];
        this.ymsStockUpInfoId = null;
        this.totalAmountOfSupplierOrders = 0;
        this.totalAmountOfDistributorOrders = 0;
      }
    }
  },
  watch: {
    priceAdjustmentList: {
      handler(data) {
        if (data.length > 0) {
          this.totalAmountOfDistributorOrders = data.reduce((accumulator, currentValue) => {
            return accumulator + currentValue.distributorPayAmount;
          }, 0);
          this.totalAmountOfSupplierOrders = data.reduce((accumulator, currentValue) => {
            return accumulator + currentValue.supplierPayAmount;
          }, 0);
        }
      },
      deep: true
    }
  },
  components: {}
};
</script>

<style lang="less" scoped>
/deep/ .priceAdjustmentStyle {
  .ivu-modal-body {
    max-height: 650px;
    overflow-y: auto;

    .set_productInfo_box {
      .ivu-table-cell {
        display: flex;
        align-items: center;
        justify-content: space-between;

        .productInfo_content {
          order: 1;
        }

        .ivu-table-cell-tree {
          order: 2;
        }
      }
    }
  }
}
</style>
